export type TriggerSize = Pick<
  HTMLElement,
  'offsetWidth' | 'scrollWidth' | 'offsetHeight' | 'scrollHeight'
>;

// + 1 is a workaround for Firefox issues with
// wrong scrollHeight value on text nodes
export const shouldShowTooltip = (trigger: TriggerSize): boolean =>
  trigger.offsetWidth < trigger.scrollWidth ||
  trigger.offsetHeight + 1 < trigger.scrollHeight;
